import { Users, UserPlus, Snowflake, Martini, Wine } from "lucide-react";

export const BUILD_PACKAGES = [
  { id: "essentials", name: "The Essentials", price: 500, note: "Bartender, basic mixers & soda, garnish, glassware, tools · 75+ guests: 2nd bartender required" },
  { id: "full_pour", name: "The Full Pour", price: 800, note: "Everything in Essentials + premium mixers & 3 signature cocktails · 100+ guests: 2nd bartender required", popular: true },
  { id: "zero_proof", name: "The Zero Proof", price: 400, note: "Bartender + crafted mocktail menu — matcha, tea infusions & lemonades · 75+ guests: 2nd bartender required" },
];

export const BUILD_ADDONS = [
  { id: "mobile_bar", icon: Wine, name: "Portable mobile bar", price: 150, copy: "Our styled portable bar, delivered and set up at your venue." },
  { id: "extra_bartender", icon: Users, name: "Extra bartender", price: 250, copy: "Keep the line moving for bigger crowds." },
  { id: "extra_server", icon: UserPlus, name: "Extra server", price: 200, copy: "Extra hands for passed drinks and bussing." },
  { id: "frozen_machine", icon: Snowflake, name: "Frozen machine", price: 150, copy: "Frozen margaritas and daiquiris all night." },
  { id: "two_more_cocktails", icon: Martini, name: "2 additional signature cocktails", price: 100, copy: "Two more custom pours for your event." },
];

export const ADDON_LABELS = {
  mobile_bar: "Portable mobile bar (+$150)",
  extra_bartender: "Extra bartender (+$250)",
  extra_server: "Extra server (+$200)",
  frozen_machine: "Frozen machine (+$150)",
  two_more_cocktails: "2 additional signature cocktails (+$100)",
};

export const DEPOSIT_LOOKUP = { essentials: "booking_deposit_essentials", full_pour: "booking_deposit_full_pour", zero_proof: "booking_deposit_zero_proof" };

export function calcBuild(build) {
  const buildPkg = BUILD_PACKAGES.find((p) => p.id === build.pkg);
  const hours = build.hours || 0;
  const clusters = build.extraGuests || 0;
  const addonsTotal = BUILD_ADDONS.filter((a) => build.addons.includes(a.id)).reduce((s, a) => s + a.price, 0);
  const hoursTotal = hours * 125;
  const guestsTotal = clusters * 100;
  const buildTotal = (buildPkg?.price || 0) + addonsTotal + hoursTotal + guestsTotal;
  return { buildPkg, hours, clusters, addonsTotal, hoursTotal, guestsTotal, buildTotal };
}
